<template>
  <div>
    <el-breadcrumb separator-icon="ArrowRight" style="margin: 16px">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>宿舍管理</el-breadcrumb-item>
      <el-breadcrumb-item>房间预订</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card style="margin: 15px; min-height: calc(100vh - 111px)">
      <div>
        <!-- 筛选和添加区 -->
        <div style="margin: 10px 0; display: flex; gap: 10px; align-items: center; flex-wrap: wrap;">
          <el-select v-model="filterClass" clearable placeholder="按班级筛选" @change="filterBookings" style="width: 200px;">
            <el-option v-for="item in classOptions" :key="item.id" :label="item.className" :value="item.id" />
          </el-select>
          <el-select v-model="filterRoom" clearable placeholder="按房间筛选" @change="filterBookings" style="width: 200px;">
            <el-option v-for="item in roomOptions" :key="item.dormRoomId" :label="item.dormRoomId" :value="item.dormRoomId" />
          </el-select>
          <el-button icon="refresh-left" @click="resetFilter">重置</el-button>
          <div style="margin-left: auto;">
            <el-tooltip content="添加预订" placement="top">
              <el-button icon="plus" style="width: 50px" type="primary" @click="add"></el-button>
            </el-tooltip>
          </div>
        </div>

        <!--    表格-->
        <el-table v-loading="loading" :data="tableData" border max-height="550" style="width: 100%">
          <el-table-column label="班级" prop="className" />
          <el-table-column label="房间" prop="roomName" />
          <el-table-column label="入住日期" prop="checkInDate" sortable />
          <el-table-column label="退房日期" prop="checkOutDate" sortable />
          <el-table-column label="状态" width="120px">
            <template #default="scope">
              <el-tag v-if="scope.row.status === 1" type="success">有效</el-tag>
              <el-tag v-else-if="scope.row.status === 0" type="info">已取消</el-tag>
              <el-tag v-else type="warning">{{ scope.row.status }}</el-tag>
            </template>
          </el-table-column>
          <!--      操作栏-->
          <el-table-column label="操作" width="130px">
            <template #default="scope">
              <el-button icon="Edit" type="primary" @click="handleEdit(scope.row)"></el-button>
              <el-popconfirm title="确认取消预订？" @confirm="handleCancel(scope.row.bookingId)">
                <template #reference>
                  <el-button icon="Delete" type="danger"></el-button>
                </template>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>

        <!--分页-->
        <div style="margin: 10px 0">
          <el-pagination v-model:currentPage="currentPage" :page-size="pageSize" :page-sizes="[10, 20]" :total="total"
            layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange">
          </el-pagination>
        </div>

        <!--      弹窗-->
        <div>
          <el-dialog v-model="dialogVisible" :title="judge ? '编辑预订' : '添加预订'" width="30%" @close="cancel">
            <el-form ref="form" :model="form" :rules="rules" label-width="120px">
              <el-form-item label="班级" prop="classId">
                <el-select v-model="form.classId" filterable placeholder="选择班级" style="width: 80%" @change="handleClassChange">
                  <el-option v-for="item in classOptions" :key="item.id" :label="item.className" :value="item.id" />
                </el-select>
              </el-form-item>
              <el-form-item label="房间" prop="dormroomIds">
                <el-select v-model="form.dormroomIds" filterable multiple collapse-tags collapse-tags-tooltip placeholder="选择房间（可多选）" style="width: 80%" @change="handleRoomChange">
                  <el-option v-for="item in roomOptions" :key="item.dormRoomId" :label="item.dormRoomId + '栋'" :value="item.dormRoomId">
                    <span>{{ item.dormRoomId }}</span>
                    <span style="float:right; color:#999; font-size:12px">{{ item.currentCapacity || 0 }}/{{ item.maxCapacity || 0 }}人 {{ item.roomType || '' }}</span>
                  </el-option>
                </el-select>
                <div v-if="conflictInfo.length > 0" style="margin-top:5px;">
                  <el-tag v-for="cf in conflictInfo" :key="cf.dormroomId + cf.type" type="danger" size="small" style="margin:2px;">
                    {{ cf.dormroomId }} {{ cf.type }}: {{ cf.className }} {{ cf.dateRange }}
                  </el-tag>
                </div>
                <div v-if="selectedCount > 0 && conflictInfo.length === 0" style="margin-top:5px; color:#67C23A; font-size:12px;">
                  已选{{ selectedCount }}个房间，无时间冲突
                </div>
              </el-form-item>
              <el-form-item label="入住日期" prop="checkInDate">
                <el-date-picker v-model="form.checkInDate" type="date" placeholder="选择入住日期" style="width: 80%" value-format="YYYY-MM-DD"></el-date-picker>
              </el-form-item>
              <el-form-item label="退房日期" prop="checkOutDate">
                <el-date-picker v-model="form.checkOutDate" type="date" placeholder="选择退房日期" style="width: 80%" value-format="YYYY-MM-DD"></el-date-picker>
              </el-form-item>
            </el-form>
            <template #footer>
              <span class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="save">确 定</el-button>
              </span>
            </template>
          </el-dialog>
        </div>
      </div>
    </el-card>
  </div>
</template>
<script src="@/assets/js/RoomBooking.js"></script>
<style scoped>
@import '../assets/css/RoomBooking.css';
</style>
